<template>
    <div class="mx-8 mb-8">
        <v-card class="elevation-0 py-4 px-8">
            <v-data-table
                :options.sync="options" 
                :footer-props="{'items-per-page-options':[15, 30, 50, meta.total]}"
                :server-items-length="meta.total"
                :headers="headers" 
                :items="tableItems"
                :loading="loader">
                <!-- Header -->
                <template v-slot:top>
                    <v-toolbar flat>
                        <v-toolbar-title>Producción</v-toolbar-title>
                    </v-toolbar>
                </template>
                <template v-slot:[`item.is_completed`]="{ item }">
                    <v-icon>{{item.is_completed?'mdi-check':'mdi-close'}}</v-icon>
                </template>
                <template v-slot:[`item.sale`]="{ item }">
                    <v-list-item :to="'/sales/'+ item.sale">{{item.sale}}</v-list-item>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>

<script>
export default {
    data(){
        return{
            filterMobile:false,
            show_filters:false,
            headers:[
                { text: 'Completado', value: 'is_completed' },
                { text: 'Productor', value: 'producer', sortable: false },
                { text: 'Venta', value: 'sale', sortable: false },
                { text: 'Tiempo', value: 'timing', sortable: false },
                { text: 'Creación', value: 'created_at' },
                { text: 'Edición', value: 'updated_at' },
            ],
            dates:[],
            options: {
                page: 1,
                itemsPerPage: 15,
                sortBy: ['id'],
                sortDesc: [true],
            },
        }
    },
    watch: {
        options: {
            handler() {
                this.fetchData()
            },
            deep: true,
        },
    },
    methods:{
        openFilter(){
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                this.filterMobile = true
            }else{
                this.show_filters?(this.$emit("closeDrawer", true), this.show_filters = false):(this.$emit("closeDrawer", false), this.show_filters = true)
            }
        },
        closeFilter(){
            this.filterMobile = false
        },
        fetchData(){
            this.$store.dispatch('mfProduction/getData', this.options)
        }
    },
    mounted() {
        this.fetchData()
    },
    computed: {
        tableItems(){
            return this.$store.state.mfProduction.data.map(item=>{return{
                ...item,
                producer:item.producer.name + ' ' + item.producer.last,
                sale:item.sale.id,
                created_at:new Date(item.created_at).toLocaleString("sv-SE", {timeZone: "America/Monterrey"}).toString().slice(0, 19),
                updated_at:new Date(item.updated_at).toLocaleString("sv-SE", {timeZone: "America/Monterrey"}).toString().slice(0, 19),
            }})
        },
        meta(){
            return this.$store.state.mfProduction.meta
        },
        filtersLength(){
            return this.$store.state.mfProduction.filters_length;
        },
        loader(){
            return this.$store.state.mfProduction.loader
        },
    },
}
</script>
<style>
.v-data-table__progress th{
    display: table-cell;
    padding-bottom:5px!important;
}
</style>